export default __webpack_public_path__ + "05554191b66fc38f6b65e33c677511d1.png";